import getTradesByCode from "../../services/getters/trade_getters/get_trades_by_code";
import loadTrades from "../../actions/react_query/trades/load_trades";
import useQueryWithState from "../use_query_with_state";

const useTrades = (projectId: string) => {
  return useQueryWithState(["useTrades", [projectId]], loadTrades, getTradesByCode, { enabled: !!projectId }, { projectId }, projectId);
};

export default useTrades;
